<template>
  <div>
          <b-row class="mb-2">
      <!-- Total Logs -->
      <b-col sm="6" xl="3">
        <b-card>
          <div class="d-flex align-items-start justify-content-between">
            <div>
              <div class="d-flex align-items-end mb-1">
                <h3 class="mb-0 mr-1">{{ tableConfigs.totalElements || 0 }}</h3>
              </div>
              <small>Total de Logs</small>
            </div>
            <b-avatar variant="light-primary" size="45">
              <feather-icon icon="FileTextIcon" size="21" />
            </b-avatar>
          </div>
        </b-card>
      </b-col>

      <!-- Logs on current view -->
      <b-col sm="6" xl="3">
        <b-card>
          <div class="d-flex align-items-start justify-content-between">
            <div>
              <div class="d-flex align-items-end mb-1">
                <h3 class="mb-0 mr-1">{{ listaLogs.length || 0 }}</h3>
              </div>
              <small>Logs Listados</small>
            </div>
            <b-avatar variant="light-success" size="45">
              <feather-icon icon="CheckSquareIcon" size="21" />
            </b-avatar>
          </div>
        </b-card>
      </b-col>

      <!-- Action Types -->
      <b-col sm="6" xl="3">
        <b-card>
          <div class="d-flex align-items-start justify-content-between">
            <div>
              <div class="d-flex align-items-end mb-1">
                <h3 class="mb-0 mr-1">4</h3>
              </div>
              <small>Tipos de Ação</small>
            </div>
            <b-avatar variant="light-warning" size="45">
              <feather-icon icon="ListIcon" size="21" />
            </b-avatar>
          </div>
        </b-card>
      </b-col>

      <!-- Active Users -->
      <b-col sm="6" xl="3">
        <b-card>
          <div class="d-flex align-items-start justify-content-between">
            <div>
              <div class="d-flex align-items-end mb-1">
                <h3 class="mb-0 mr-1">Auditoria</h3>
              </div>
              <small>Monitoramento Ativo</small>
            </div>
            <b-avatar variant="light-info" size="45">
              <feather-icon icon="ShieldIcon" size="21" />
            </b-avatar>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <!-- Filtros -->
        <b-card class="mb-2">
          <template #header>
            <div class="d-flex justify-content-between align-items-center w-100">
              <h4 class="mb-0">Filtros de Auditoria</h4>
              <b-button
                variant="outline-danger"
                size="sm"
                @click="exportarPdf"
              >
                <feather-icon icon="FileTextIcon" size="14" />
                <span class="ml-50">Exportar PDF</span>
              </b-button>
            </div>
          </template>

          <b-row class="align-items-center">
            <b-col cols="12" md="2">
              <b-form-group label="Data Início" label-for="filtro-data-inicio">
                <b-form-input
                  id="filtro-data-inicio"
                  v-model="filter.dataInicio"
                  type="date"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="2">
              <b-form-group label="Data Fim" label-for="filtro-data-fim">
                <b-form-input
                  id="filtro-data-fim"
                  v-model="filter.dataFinal"
                  type="date"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="2">
              <b-form-group label="Tabela" label-for="filtro-tabela">
                <b-form-select
                  id="filtro-tabela"
                  v-model="filter.tabela"
                  :options="opcoesTabela"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="2">
              <b-form-group label="Operação" label-for="filtro-operacao">
                <b-form-select
                  id="filtro-operacao"
                  v-model="filter.operacao"
                  :options="opcoesOperacao"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="3">
              <b-form-group label="Usuário" label-for="filtro-usuario">
                <b-form-select
                  id="filtro-usuario"
                  v-model="filter.userId"
                  :options="opcoesUsuario"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="1" class="d-flex align-items-center mt-50">
              <b-button
                v-b-tooltip.hover
                title="Filtrar"
                variant="primary"
                block
                @click="aplicarFiltro"
              >
                <feather-icon icon="SearchIcon" size="14" />
              </b-button>
            </b-col>
          </b-row>
        </b-card>

        <!-- Tabela -->
        <b-card title="Logs de Auditoria do Sistema">
          <vue-good-table
            mode="remote"
            :columns="columns"
            :rows="listaLogs"
            :rtl="direction"
            :is-loading.sync="isLoading"
            :pagination-options="{
              enabled: true,
              perPage: tableConfigs.size
            }"
            :total-rows="tableConfigs.totalElements"
            @on-sort-change="onSortChange"
          >
            <template slot="table-row" slot-scope="props">

              <span v-if="props.column.field === 'dataHora'">
                {{ formatDate(props.row.dataHora) }}
              </span>

              <span v-else-if="props.column.field === 'operacao'">
                <b-badge :variant="getOperacaoBadge(props.row.operacao)" pill>
                  {{ props.row.operacao }}
                </b-badge>
              </span>
              
              <span v-else-if="props.column.field === 'userName'">
                {{ props.row.userName || '-' }} <small class="text-muted">(ID: {{props.row.user}})</small>
              </span>

              <!-- Ações -->
              <span v-else-if="props.column.field === 'action'">
                <span class="d-flex align-items-center gap-50">
                  <b-button
                    v-b-tooltip.hover
                    title="Detalhes"
                    variant="flat-info"
                    class="btn-icon rounded-circle"
                    size="sm"
                    @click="abrirModalDetalhes(props.row)"
                  >
                    <feather-icon icon="EyeIcon" size="16" />
                  </b-button>
                </span>
              </span>

              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>

            <!-- Paginação -->
            <template slot="pagination-bottom" slot-scope="props">
              <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                  <span class="text-nowrap">Exibindo</span>
                  <b-form-select
                    v-model="tableConfigs.size"
                    :options="[10, 20, 50, 100]"
                    class="mx-1"
                    @input="handleChangePage(1)"
                  />
                  <span class="text-nowrap">de {{ tableConfigs.totalElements }} registros</span>
                </div>
                <b-pagination
                  v-model="currentPage"
                  :total-rows="tableConfigs.totalElements"
                  :per-page="tableConfigs.size"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @change="handleChangePage"
                >
                  <template #prev-text><feather-icon icon="ChevronLeftIcon" size="18" /></template>
                  <template #next-text><feather-icon icon="ChevronRightIcon" size="18" /></template>
                </b-pagination>
              </div>
            </template>
          </vue-good-table>
        </b-card>
      </b-col>
    </b-row>

    <!-- Modal Detalhes -->
    <b-modal
      id="modal-detalhes-log"
      title="Detalhes do Registro de Auditoria"
      size="xl"
      ok-only
      ok-title="Fechar"
      scrollable
    >
      <div v-if="logSelecionado">
        <!-- Header / Informações Gerais -->
        <b-card class="mb-2" no-body>
          <div class="card-header border-bottom">
            <h5 class="card-title mb-0">Informações Gerais</h5>
          </div>
          <b-card-body class="pt-2">
            <b-row class="px-1">
              <b-col md="6" class="mb-2">
                <label class="font-weight-bold text-uppercase small text-muted d-block">Ação</label>
                <b-badge :variant="getOperacaoBadge(logSelecionado.operacao)" class="font-medium-1">
                  {{ logSelecionado.operacao === 'INSERT' ? 'Criação' : logSelecionado.operacao === 'UPDATE' ? 'Atualização' : logSelecionado.operacao === 'DELETE' ? 'Exclusão' : logSelecionado.operacao }}
                </b-badge>
              </b-col>
              <b-col md="6" class="mb-2">
                <label class="font-weight-bold text-uppercase small text-muted d-block">Data/Hora</label>
                <div class="h5 mb-0">{{ formatDate(logSelecionado.dataHora) }}</div>
              </b-col>
              <b-col md="6" class="mb-2">
                <label class="font-weight-bold text-uppercase small text-muted d-block">Usuário</label>
                <div class="h5 mb-0">
                   <span v-if="logSelecionado.userName" class="font-weight-bolder">{{ logSelecionado.userName }}</span>
                   <span v-else class="text-muted">Sistema</span>
                   <small class="text-muted ml-50" v-if="logSelecionado.user">(ID: {{ logSelecionado.user }})</small>
                </div>
              </b-col>
              <b-col md="6" class="mb-2">
                <label class="font-weight-bold text-uppercase small text-muted d-block">Tabela / Modelo</label>
                <div class="h5 mb-0"><code>{{ logSelecionado.tabela }}</code></div>
              </b-col>
              <b-col md="12" class="mb-1">
                <label class="font-weight-bold text-uppercase small text-muted d-block">ID do Registro (Objeto)</label>
                <div class="h5 mb-0 font-weight-bolder">{{ logSelecionado.tabelaId || '-' }}</div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>

        <!-- Alterações (para UPDATE) -->
        <b-card class="mb-2" no-body v-if="logSelecionado.operacao === 'UPDATE' && getParsedValues(logSelecionado.valoresAntigos)">
          <div class="card-header border-bottom">
            <h5 class="card-title mb-0">Alterações</h5>
          </div>
          <b-card-body class="pt-2">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Campo</th>
                    <th>Valor Antigo</th>
                    <th>Valor Novo</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(oldVal, field) in getParsedValues(logSelecionado.valoresAntigos)" :key="field">
                    <td class="font-weight-bold">{{ field }}</td>
                    <td><span class="text-danger">{{ oldVal !== null ? oldVal : '-' }}</span></td>
                    <td>
                      <span class="text-success" v-if="getParsedValues(logSelecionado.valoresNovos) && getParsedValues(logSelecionado.valoresNovos)[field] !== undefined">
                        {{ getParsedValues(logSelecionado.valoresNovos)[field] !== null ? getParsedValues(logSelecionado.valoresNovos)[field] : '-' }}
                      </span>
                      <span class="text-muted" v-else>-</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-card-body>
        </b-card>

        <!-- Dados Deletados (para DELETE) -->
        <b-card class="mb-2" no-body v-if="logSelecionado.operacao === 'DELETE' && getParsedValues(logSelecionado.valoresAntigos)">
          <div class="card-header border-bottom">
            <h5 class="card-title mb-0">Dados do Objeto Deletado</h5>
          </div>
          <b-card-body class="pt-2">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Campo</th>
                    <th>Valor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(val, field) in getParsedValues(logSelecionado.valoresAntigos)" :key="field">
                    <td class="font-weight-bold">{{ field }}</td>
                    <td><span class="text-danger">{{ val !== null ? val : '-' }}</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-card-body>
        </b-card>

        <!-- Dados Criados (para INSERT) -->
        <b-card class="mb-2" no-body v-if="logSelecionado.operacao === 'INSERT' && getParsedValues(logSelecionado.valoresNovos)">
          <div class="card-header border-bottom">
            <h5 class="card-title mb-0">Dados Criados</h5>
          </div>
          <b-card-body class="pt-2">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Campo</th>
                    <th>Valor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(val, field) in getParsedValues(logSelecionado.valoresNovos)" :key="field">
                    <td class="font-weight-bold">{{ field }}</td>
                    <td><span class="text-success">{{ val !== null ? val : '-' }}</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-card-body>
        </b-card>

        <!-- Json Data -->
        <b-card no-body>
          <div class="card-header border-bottom">
            <h5 class="card-title mb-0">Detalhes Técnicos</h5>
          </div>
          <b-card-body class="pt-2 pb-1">
            <b-row class="mb-2 px-1">
               <b-col md="6" class="mb-1">
                 <label class="font-weight-bold text-uppercase small text-muted d-block">Banco de Dados / Schema</label>
                 <div class="h5 mb-0"><code>{{ logSelecionado.schema || 'public' }}</code></div>
               </b-col>
               <b-col md="6" class="mb-1">
                 <label class="font-weight-bold text-uppercase small text-muted d-block">Log Interno ID</label>
                 <div class="h5 mb-0">#{{ logSelecionado.id }}</div>
               </b-col>
            </b-row>
            <b-row class="px-1">
              <b-col cols="12" md="6" v-if="logSelecionado.valoresAntigos && logSelecionado.valoresAntigos !== 'null'">
                <label class="font-weight-bold text-uppercase small text-muted d-block mb-1">Valores Antigos (JSON)</label>
                <div class="bg-light p-1 rounded border shadow-sm" style="max-height: 400px; overflow-y: auto;">
                  <pre class="mb-0" style="font-size: 0.85rem; line-height: 1.4; color: #d63384;"><code>{{ formatJson(logSelecionado.valoresAntigos) }}</code></pre>
                </div>
              </b-col>
              <b-col cols="12" md="6" v-if="logSelecionado.valoresNovos && logSelecionado.valoresNovos !== 'null'">
                <label class="font-weight-bold text-uppercase small text-muted d-block mb-1">Valores Novos (JSON)</label>
                <div class="bg-light p-1 rounded border shadow-sm" style="max-height: 400px; overflow-y: auto;">
                  <pre class="mb-0" style="font-size: 0.85rem; line-height: 1.4; color: #198754;"><code>{{ formatJson(logSelecionado.valoresNovos) }}</code></pre>
                </div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </div>
    </b-modal>

  </div>
</template>

<script>
import axios from '@axios'
import { mapState } from 'vuex'
import { VueGoodTable } from 'vue-good-table'
import {
  BRow, BCol, BCard, BBadge, BButton,
  BPagination, BFormGroup, BFormInput, BFormSelect, BModal, VBTooltip, BAvatar
} from 'bootstrap-vue'
import store from '@/store/index'

export default {
  name: 'AuditLogsList',
  components: {
    BRow, BCol, BCard, BBadge, BButton, BPagination,
    BFormGroup, BFormInput, BFormSelect, BModal, BAvatar,
    VueGoodTable
  },
  directives: { 'b-tooltip': VBTooltip },

  computed: {
    ...mapState('auditModule', {
      listaLogs: state => state.listaLogs
    }),
    direction() {
      return store.state.appConfig.isRTL
    }
  },

  data() {
    const hoje = new Date()
    const pDia = new Date(hoje.getFullYear(), hoje.getMonth(), 1)
    const toInputDate = d => {
      // Ajuste para pegar dd/MM/yyyy certinho local
      // O input date html5 precisa do formato yyyy-mm-dd
      return d.toISOString().split('T')[0]
    }

    // backend filter requires dd/MM/yyyy. Mas o backend do log tá aceitando LocalDate padrão ISO pelo Spring? 
    // "O backend recebe dd/MM/yyyy"? Vamos mandar dd/MM/yyyy pra garantir como no FilterComponents
    const pad = n => n<10?'0'+n:n
    const toBrDate = d => `${pad(d.getDate())}/${pad(d.getMonth()+1)}/${d.getFullYear()}`

    return {
      isLoading: false,
      filter: {
        dataInicio: toInputDate(pDia),
        dataFinal: toInputDate(hoje),
        tabela: null,
        operacao: null,
        userId: null
      },
      logSelecionado: null,

      opcoesOperacao: [
        { value: null, text: 'Todas' },
        { value: 'INSERT', text: 'Inserção' },
        { value: 'UPDATE', text: 'Atualização' },
        { value: 'DELETE', text: 'Exclusão' }
      ],
      opcoesUsuario: [{ value: null, text: 'Todos' }],
      opcoesTabela: [{ value: null, text: 'Todas' }],

      currentPage: 1,
      pageConfig: { page: 1, size: 20 },
      tableConfigs: { totalElements: 0, totalPages: 0, size: 20 },

      columns: [
        { label: 'ID',          field: 'id',       sortable: false },
        { label: 'Ação',        field: 'operacao', sortable: false },
        { label: 'Usuário',     field: 'userName', sortable: false },
        { label: 'Modelo',      field: 'tabela',   sortable: false },
        { label: 'Objeto',      field: 'tabelaId', sortable: false },
        { label: 'Data/Hora',   field: 'dataHora', sortable: false },
        { label: 'Ações',       field: 'action',   sortable: false }
      ]
    }
  },

  mounted() {
    this.carregarOpcoesDinamicas()
    this.carregarTabela()
  },

  methods: {
    async carregarOpcoesDinamicas() {
      try {
        const [resUsers, resTabelas] = await Promise.all([
          axios.get('/usuarios?page=0&size=500'),
          axios.get('/core/logs/tabelas')
        ]).catch(e => { console.error('Error fetching options', e); return [null, null] })

        if (resUsers && resUsers.data && resUsers.data.content) {
          const uOpts = resUsers.data.content
            .filter(u => !(u.email || '').toLowerCase().includes('sysfactech'))
            .map(u => ({ 
              value: u.id, 
              text: `${u.firstName} ${u.lastName || ''} (${u.email || 'Sem E-mail'})` 
            }))
          this.opcoesUsuario = [{ value: null, text: 'Todos os Usuários' }, ...uOpts]
        }
        
        if (resTabelas && resTabelas.data) {
          const tOpts = resTabelas.data
            .map(t => ({ value: t, text: t }))
          this.opcoesTabela = [{ value: null, text: 'Todas as Tabelas' }, ...tOpts]
        }
      } catch (err) {
        console.error('Erro ao processar opções dinâmicas', err)
      }
    },
    getOperacaoBadge(op) {
      if(op === 'INSERT') return 'light-success'
      if(op === 'UPDATE') return 'light-warning'
      if(op === 'DELETE') return 'light-danger'
      return 'light-secondary'
    },
    formatDate(isoString) {
      if(!isoString) return '-'
      const d = new Date(isoString)
      const pad = n => n<10?'0'+n:n
      return `${pad(d.getDate())}/${pad(d.getMonth()+1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`
    },
    formatJson(val) {
      if (!val || val === 'null') return 'N/D'
      try {
        // Se já for um objeto (ou array)
        if (typeof val === 'object') {
          return JSON.stringify(val, null, 2)
        }
        // Se for string, tenta fazer o parse
        const obj = JSON.parse(val)
        return JSON.stringify(obj, null, 2)
      } catch (e) {
        // Se falhar o parse, retorna o valor original
        return val
      }
    },
    async aplicarFiltro() {
      this.currentPage = 1
      this.pageConfig.page = 1
      await this.carregarTabela()
    },
    async carregarTabela() {
      this.isLoading = true
      
      const fmtDataInputParaBR = (dIso) => {
         if (!dIso) return null
         const parts = dIso.split('-')
         if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`
         return dIso
      }

      const payload = {
        dataInicio: fmtDataInputParaBR(this.filter.dataInicio),
        dataFinal: fmtDataInputParaBR(this.filter.dataFinal),
        tabela: this.filter.tabela,
        operacao: this.filter.operacao,
        userId: this.filter.userId
      }

      try {
        const result = await this.$store.dispatch('auditModule/buscarComFiltros', {
          filter: payload,
          pageConfig: this.pageConfig
        })

        if (result && result.data) {
          this.tableConfigs.totalElements = result.data.totalElements
          this.tableConfigs.totalPages = result.data.totalPages
          this.tableConfigs.size = result.data.size
        }
      } catch(err) {
        console.error('Erro ao buscar logs', err)
      }
      this.isLoading = false
    },
    handleChangePage(page) {
      this.pageConfig.page = page
      this.pageConfig.size = this.tableConfigs.size
      this.carregarTabela()
    },
    onSortChange(params) {
      // API currently may not support dynamic sorting without changes securely, but standard setup
    },
    
    getParsedValues(valStr) {
      if (!valStr || valStr === 'null') return null;
      try {
        const parsed = JSON.parse(valStr);
        if (typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed)) {
          return parsed;
        }
        return null;
      } catch(e) {
        return null;
      }
    },

    abrirModalDetalhes(row) {
      this.logSelecionado = row
      this.$bvModal.show('modal-detalhes-log')
    },
    async exportarPdf() {
      if (!this.listaLogs || this.listaLogs.length === 0) {
        this.$bvToast.toast('Nenhum dado para exportar', { title: 'Atenção', variant: 'warning' })
        return
      }
      
      const fmtDataInputParaBR = (dIso) => {
         if (!dIso) return null
         const parts = dIso.split('-')
         if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`
         return dIso
      }

      // Preparando os logs para o PDF
      const formatDataHora = (isoStr) => {
        if(!isoStr) return '-'
        const d = new Date(isoStr)
        const p = n => n<10?'0'+n:n
        return `${p(d.getDate())}/${p(d.getMonth()+1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`
      }

      const logsParaEnvio = this.listaLogs.map(l => ({
        ...l,
        dataHora: formatDataHora(l.dataHora),
        valoresAntigos: l.valoresAntigos ? JSON.stringify(JSON.parse(l.valoresAntigos)) : '',
        valoresNovos: l.valoresNovos ? JSON.stringify(JSON.parse(l.valoresNovos)) : ''
      }))

      const payload = {
        dataInicioFormatada: fmtDataInputParaBR(this.filter.dataInicio) || '-',
        dataFimFormatada: fmtDataInputParaBR(this.filter.dataFinal) || '-',
        tabela: this.filter.tabela,
        operacao: this.filter.operacao,
        usuarioTexto: this.filter.userId ? `ID: ${this.filter.userId}` : null,
        logs: logsParaEnvio
      }

      this.$bvToast.toast('Gerando PDF...', { title: 'Aguarde', variant: 'info' })
      try {
        const res = await this.$store.dispatch('reportModule/printReportAuditoria', payload)
        if (res && res.error) {
          this.$bvToast.toast(res.error, { title: 'Erro', variant: 'danger' })
        }
      } catch (e) {
        this.$bvToast.toast('Erro ao gerar PDF', { title: 'Erro', variant: 'danger' })
      }
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>

<style scoped>
pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>
